import dynamic from 'next/dynamic';
import type { ReactAiTool, ReactAiToolComponent } from '@erikdakoda/ai-tool-ui/types';
import {
  createArtifactsTool,
  type ArtifactInput,
  type ArtifactOutput,
} from '@erikdakoda/artifact/ai-tools/artifacts';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';
import { isStdioMcpEnabled } from '@erikdakoda/utils/isStdioMcpEnabled';

const artifacts = createArtifactsTool(isStdioMcpEnabled());

(artifacts as ReactAiTool<ArtifactInput, ArtifactOutput>).component = dynamic(
  () => import('../ai-tool-components/Artifact'),
) as ReactAiToolComponent<ArtifactInput, ArtifactOutput>;

registerAiTool(artifacts);
